<template>
  <v-layout column>
    <v-flex>
      <HeaderBar>
        <v-icon slot="icon">account_circle</v-icon>
        My Profile
      </HeaderBar>
    </v-flex>
    <v-flex v-if="gettingProfile">
      <v-progress-linear indeterminate></v-progress-linear>
    </v-flex>
    <v-flex v-else>
      <v-layout row wrap>
        <v-flex xs12 md6 class="mr-2">
          <div class="mb-4">
            <v-img
              v-if="profilePictureUrl"
              height="200"
              width="200"
              contain
              :src="profilePictureUrl"
            >
            </v-img>
            <div class="subtle" v-if="!profilePictureUrl">
              No profile image
            </div>
            <a @click.prevent="showingUpload = !showingUpload" href="#"
              >Add/Edit Picture</a
            >

            <div v-show="showingUpload">
              <Uploader
                v-model="photo"
                accept="image/*"
                @presigned="profile_picture_data = $event"
              >
              </Uploader>

              <image-preview> </image-preview>

              <v-btn
                @click.prevent="savePhoto()"
                v-show="chosenFilename"
                :disabled="!presignedPresent"
                color="success"
                :loading="!presignedPresent"
                >Save Image</v-btn
              >
            </div>
          </div>
          <v-flex> </v-flex>
          <EmployeeField
            fieldType="textarea"
            label="Bio"
            fieldName="bio"
            :object="profile"
          />
        </v-flex>
        <v-flex>
          <EmployeeField
            fieldType="text"
            label="Street Adddress"
            fieldName="street_address"
            :object="profile"
          />
          <EmployeeField
            fieldType="text"
            label="City"
            fieldName="city"
            :object="profile"
          />

          <EmployeeSelect
            label="State"
            fieldName="state"
            :object="profile"
            :items="states"
          />
          <EmployeeField
            fieldType="text"
            label="Zip Code"
            fieldName="zip"
            :object="profile"
          />
          <v-layout row justify-space-between>
            <EmployeeField
              fieldType="text"
              label="Phone"
              fieldName="phone"
              :object="profile"
            />

            <EmployeeCheckboxField
              fieldType="switch"
              label="Receive SMS"
              fieldName="sms_opt_out"
              :object="profile"
            />
          </v-layout>
          <v-text-field disabled label="Email" v-model="email"> </v-text-field>
          <v-flex shrink>
            <ErContactEditor
              :employeeId="userId"
              :contacts="erContacts"
              :afterCallback="getUserProfile"
            />
          </v-flex>
        </v-flex>
      </v-layout>
      <v-divider class="mt-4"></v-divider>
      <v-layout column class="mt-4">
        <v-flex>
          <h2>Dosimetry Badge</h2>
          <v-layout>
            <v-flex>
              <v-menu
                ref="dateMenu"
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="internalLastDosimetryUpload"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template slot="activator" slot-scope="{ on }">
                  <v-text-field
                    :disabled="dosimetryLoading"
                    label="Last dosimetry badge upload"
                    format="dddd, MMM DD YYYY"
                    :loading="dosimetryLoading"
                    v-model="internalLastDosimetryUpload"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="internalLastDosimetryUpload"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="dateMenu = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    flat
                    color="primary"
                    @click="$refs.dateMenu.save(internalLastDosimetryUpload)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-btn
                :disabled="!dosimetryChanged"
                :pending="dosimetryLoading"
                @click="saveDosimetry"
                color="success"
                >Save</v-btn
              >
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-divider class="mt-4"></v-divider>
      <v-layout column class="mt-4">
        <v-flex xs2>
          <PasswordResetDialog :toSelf="true" :email="email" />
        </v-flex>

        <v-flex xs12>
          <v-layout row>
            <template v-for="setting in orderedMessagePreferences">
              <v-checkbox
                v-if="!setting[Object.keys(setting)[0]].managerOverride"
                :key="Object.keys(setting)[0]"
                :label="preferenceLabel(setting)"
                v-model="setting[Object.keys(setting)[0]].userSetting"
                @change="updateMessagePreferences"
                v-show="showPref(setting)"
              />
              <v-checkbox
                v-else
                :key="Object.keys(setting)[0]"
                :label="`${preferenceLabel(setting)} (manager override)`"
                v-model="setting[Object.keys(setting)[0]].managerOverride"
                v-show="showPref(setting)"
                disabled
              />
            </template>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="mt-3">
          <div class="subheading">Default calendar view</div>
          <v-radio-group v-model="defaultCalendarView" row>
            <v-radio label="List" value="list"></v-radio>
            <v-radio label="Month" value="month"></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import EmployeeField from "@/components/hr/employee-field.vue";
import EmployeeCheckboxField from "@/components/hr/employee-checkbox-field.vue";
import EmployeeSelect from "@/components/hr/employee-select.vue";
import ErContactEditor from "@/components/hr/er-contact-editor.vue";
import PasswordResetDialog from "@/components/hr/password-reset-dialog.vue";
import collectionsApi from "@/api/collections";

export default {
  components: {
    EmployeeField,
    EmployeeCheckboxField,
    EmployeeSelect,
    ErContactEditor,
    PasswordResetDialog
  },
  computed: {
    ...mapState("userAuth", ["user"]),
    dosimetryChanged() {
      return (
        this.internalLastDosimetryUpload !==
        this.profile.last_dosimetry_upload_date
      );
    },
    receiveEmail() {
      const globalPref = this.profile.message_preferences.global;

      if (globalPref.managerOverride) {
        return true;
      } else {
        return globalPref.userSetting;
      }
    },

    orderedMessagePreferences() {
      // Employee does not have priveleges to set pickup preference
      // Only a client can
      delete this.profile.message_preferences.pickup;

      const prefs = Object.entries(this.profile.message_preferences).map(
        ([k, v]) => {
          return { [k]: v };
        }
      );

      // move 'global' to the top of the list:
      return prefs.reduce((accum, pref) => {
        if (Object.keys(pref)[0] === "global") {
          return [pref, ...accum];
        }
        return [...accum, pref];
      }, []);
    },

    presignedPresent: function() {
      if (this.profile_picture_data && this.profile_picture_data.id) {
        return true;
      } else {
        return false;
      }
    },
    chosenFilename: function() {
      return this.$store.state.uploader.fileName;
    },
    defaultCalendarView: {
      get () {
        return this.user.defaultCalendarView || 'list'
      },
      set (value) {
        this.$store.dispatch('userAuth/setDefaultCalendarView', value)
      },
    },
  },
  created() {
    this.setUp();
  },
  watch: {
    receiveSMS() {
      this.$store
        .dispatch("employees/updateOwnProfile", {
          street_address: this.street_address,
          city: this.city,
          state: this.state,
          zip: this.zip,
          phone: this.phone,
          bio: this.bio,
          sms_opt_out: !this.receiveSMS
        })
        .then(res => {
          this.setUpComponentFromParams(res);
          this.$store.dispatch("global/showSnackbarSuccess", {
            message: "Your profile has been updated!"
          });
        })
        .catch(err => {
          console.log(err);
          this.$store.dispatch("global/showSnackbarError", {
            message: "Something went wrong..."
          });
        })
        .finally(res => {
          this.updatingProfile = false;
        });
    }
  },
  data: function() {
    return {
      dateMenu: false,
      internalLastDosimetryUpload: null,
      dosimetryLoading: false,
      profile: null,
      userId: null,
      photo: null,
      gettingProfile: false,
      updatingProfile: false,
      profilePictureUrl: "",
      profile_picture_data: null,
      showingUpload: false,
      erContacts: null,
      states: collectionsApi.getStates()
    };
  },
  methods: {
    setUpComponentFromParams(params) {
      this.userId = params.userId;
      this.profilePictureUrl = params.profilePictureUrl;
      this.email = params.email;
      this.erContacts = params.erContacts;
      this.internalLastDosimetryUpload = params.last_dosimetry_upload_date;
    },

    saveDosimetry() {
      this.dosimetryLoading = true;

      this.$store
        .dispatch("profiles/update", {
          last_dosimetry_upload_date: this.internalLastDosimetryUpload
        })
        .then(profile => {
          this.profile = profile;
          this.$store.dispatch("global/showSnackbarSuccess", {
            message: "Dosimetry upload date saved!"
          });
        })
        .catch(err => {
          console.log(err);
          this.$store.dispatch("global/showSnackbarError", {
            message: "Something went wrong..."
          });
        })
        .finally(res => {
          this.dosimetryLoading = false;
        });
    },

    setUp() {
      this.getUserProfile();
    },
    getUserProfile() {
      this.gettingProfile = true;
      this.$store
        .dispatch("profiles/get")
        .then(profile => {
          this.profile = profile;
          this.setUpComponentFromParams(profile);
        })
        .finally(r => {
          this.gettingProfile = false;
        });
    },
    savePhoto() {
      this.$store
        .dispatch("employees/savePhoto", {
          id: this.user.id,
          profile_picture_data: this.profile_picture_data
        })
        .finally(res => {
          this.$store.commit("uploader/setImage", null);
          this.$store.commit("uploader/setFilename", "");
          this.$store.dispatch("profiles/get").then(profile => {
            this.profilePictureUrl = profile.profilePictureUrl;
          });
          this.showingUpload = false;
        });
    },

    showPref(setting) {
      const key = Object.keys(setting)[0];
      if (key === "global") {
        return true;
      }

      if (!this.receiveEmail) {
        return false;
      } else {
        return true;
      }
    },

    preferenceLabel(setting) {
      // get the key name from the settings object:
      const key = Object.keys(setting)[0];

      switch (key.toString()) {
        case "global":
          return "Receive message emails";
        case "shiftReminder":
          return "Shift reminders";
        case "important":
          return "Important and time-sensitive messages";
        case "default":
          return "All other messages";
      }
    },

    updateMessagePreferences() {
      this.$store
        .dispatch("profiles/update", {
          message_preferences: this.profile.message_preferences
        })
        .then(profile => {
          this.profile = profile;
          this.$store.dispatch("global/showSnackbarSuccess", {
            message: "Message preferences updated"
          });
        })
        .catch(e => {
          this.$store.dispatch("global/showSnackbarError", {
            message: "Something went wrong"
          });
        });
    }
  }
};
</script>

<style scoped></style>
